import get from 'lodash/get';

const ORGANIZERS_LIMIT = 18;

const removeNullValues = (organizerId) => organizerId;
const getUniqueValues = (organizerIds) => [...new Set(organizerIds)];

export const getCreatorImage = ({ collection }) => {
    let creatorImage = get(collection, ['creator', 'image', 'url']);

    if (collection.displayCreatorImageUrl) {
        creatorImage = collection.displayCreatorImageUrl;
    }

    return creatorImage;
};

export const getOrganizerIds = ({ events }) => {
    const entities = events.entities;

    return getUniqueValues(
        Object.keys(entities)
            .map((index) => entities[index].primaryOrganizerId)
            .filter(removeNullValues),
    ).slice(0, ORGANIZERS_LIMIT);
};
